import React from 'react';
import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { TaxonomyThemes } from '../../../types/uncinc_profile/taxonomy';

import './style.scss';

interface ViewThemesOverviewProps {
  entities: Immutable.List<ImmutableEntity<TaxonomyThemes>>;
}

const ViewThemesOverview: React.FC<ViewThemesOverviewProps> = ({
  entities,
}) => {
  const parentThemes = entities
    .filter((entity) => entity.getIn(['parent', 0, 'target_id'], null) === null)
    .sortBy((entity) => entity.getIn(['weight', 0, 'value'], 0));

  return (
    <div className="ViewThemesOverview">
      <div className="row">
        {parentThemes.map((entity) => {
          const theme = entity.toJS();
          const tid = theme.tid[0].value;
          const childThemes = entities
            .filter((e) => e.getIn(['parent', 0, 'target_id'], null) === tid)
            .sortBy((e) => e.getIn(['weight', 0, 'value'], 0));
          const uuid = theme.uuid[0].value;
          const langcode = theme.langcode[0].value;
          const key = `${uuid}:${langcode}`;

          return (
            <div className="ViewThemesOverview__item col-12 col-md-6" key={key}>
              <Taxonomy
                entity={entity}
                viewMode="overview_teaser"
                childThemes={childThemes}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ViewThemesOverview;
